module.exports = __webpack_public_path__ + "img/skills.7f69d36f.svg";